module.exports = __webpack_public_path__ + "static/722885fe3a59309a8039103f07de06c800121b6cbef479f46d4aa5dbbd3b0628-bf30180d5d4f00e2b25be0d6fde4be66.png";